/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsParallelAvailableSlotsResponse } from "../../entities/models/ParallelAvailableSlotsResponse";
import { modelsParallelAvailableSlotSchema } from "./parallelAvailableSlotSchema";
import { z } from "zod/v4";

export const modelsParallelAvailableSlotsResponseSchema = z.object({
    get "slots"(){
                return z.array(modelsParallelAvailableSlotSchema).optional()
              }
    }) as unknown as z.ZodType<ModelsParallelAvailableSlotsResponse>